import { Link, useRouter } from "../lib/router.js";
import { useSession } from "../lib/session.js";
import {
  IconBody,
  IconChevronRight,
  IconClipboard,
  IconDumbbell,
  IconHeart,
  IconLeaf,
  IconLogout,
  IconSettings,
  IconShield,
  IconSparkles,
  IconTarget,
  IconTimeline
} from "../components/icons.js";

interface Row {
  to: string;
  label: string;
  icon: React.ReactNode;
  note?: string;
}

const SECTIONS: Row[] = [
  { to: "/goals", label: "Goals", icon: <IconTarget className="nav-icon" /> },
  { to: "/timeline", label: "Timeline", icon: <IconTimeline className="nav-icon" /> },
  { to: "/nutrition", label: "Nutrition", icon: <IconClipboard className="nav-icon" /> },
  { to: "/grocery", label: "Grocery", icon: <IconLeaf className="nav-icon" /> },
  { to: "/training", label: "Training", icon: <IconDumbbell className="nav-icon" /> },
  { to: "/recovery", label: "Recovery", icon: <IconHeart className="nav-icon" /> },
  { to: "/body", label: "Body", icon: <IconBody className="nav-icon" /> },
  { to: "/insights", label: "Insights", icon: <IconSparkles className="nav-icon" /> },
  { to: "/journal", label: "Journal", icon: <IconClipboard className="nav-icon" /> }
];

function LinkRow({ to, label, icon, note }: Row) {
  return (
    <Link to={to} className="nav-link" style={{ borderRadius: 0 }}>
      {icon}
      <span className="grow">{label}</span>
      {note && <span className="badge badge-muted">{note}</span>}
      <IconChevronRight width={18} height={18} className="dim" />
    </Link>
  );
}

export function MorePage() {
  const { user, logout } = useSession();
  const { navigate } = useRouter();

  return (
    <div>
      <div className="page-header">
        <h1>More</h1>
        <p className="subtitle">
          Signed in as {user?.displayName ?? user?.username}
        </p>
      </div>

      <div className="stack">
        <div className="card" style={{ padding: 0, overflow: "hidden" }}>
          <div className="nav-section-label" style={{ padding: "var(--space-4) var(--space-4) var(--space-2)" }}>
            Sections
          </div>
          {SECTIONS.map((row) => (
            <LinkRow key={row.to} {...row} />
          ))}
        </div>

        <div className="card" style={{ padding: 0, overflow: "hidden" }}>
          <div className="nav-section-label" style={{ padding: "var(--space-4) var(--space-4) var(--space-2)" }}>
            You
          </div>
          <LinkRow to="/life-profile" label="Life Profile — what ClovaForm knows" icon={<IconClipboard className="nav-icon" />} />
          <LinkRow to="/settings" label="Settings & account" icon={<IconSettings className="nav-icon" />} />
          {user?.role === "admin" && (
            <LinkRow to="/admin" label="Administration" icon={<IconShield className="nav-icon" />} />
          )}
        </div>

        <button
          className="btn btn-danger btn-block"
          onClick={async () => {
            await logout();
            navigate("/login", { replace: true });
          }}
        >
          <IconLogout width={18} height={18} /> Sign out
        </button>
      </div>
    </div>
  );
}
